import React from "react";
import { Badge } from "@/components/ui/badge";

const STATUS_CONFIG = {
  detected:                 { label: "Detectat",          className: "bg-blue-100 text-blue-800" },
  pending_review:           { label: "Pendent revisió",   className: "bg-yellow-100 text-yellow-800" },
  approved_as_overtime:     { label: "Aprovat extra",     className: "bg-red-100 text-red-800" },
  approved_as_complementary:{ label: "Aprovat compl.",    className: "bg-orange-100 text-orange-800" },
  rejected:                 { label: "Rebutjat",          className: "bg-gray-100 text-gray-600" },
  compensated_with_rest:    { label: "Compensat descans", className: "bg-purple-100 text-purple-800" },
  paid:                     { label: "Pagat",             className: "bg-green-100 text-green-800" },
};

const CLASS_CONFIG = {
  ordinari:                   { label: "Ordinari",              className: "bg-green-100 text-green-700" },
  possible_complementaria:    { label: "Possible compl.",       className: "bg-orange-100 text-orange-700" },
  possible_extraordinaria:    { label: "Possible extra",        className: "bg-red-100 text-red-700" },
  incidencia_fitxatge:        { label: "Incidència fitxatge",   className: "bg-gray-100 text-gray-700" },
  pendent_validacio:          { label: "Pendent validació",     className: "bg-yellow-100 text-yellow-700" },
};

export function StatusBadge({ status }) {
  const cfg = STATUS_CONFIG[status] || { label: status, className: "bg-gray-100 text-gray-600" };
  return <Badge className={`text-xs font-medium ${cfg.className}`}>{cfg.label}</Badge>;
}

export function ClassificationBadge({ classification }) {
  const cfg = CLASS_CONFIG[classification] || { label: classification, className: "bg-gray-100 text-gray-600" };
  return <Badge className={`text-xs font-medium ${cfg.className}`}>{cfg.label}</Badge>;
}